import get from './get';
import save from './save';
import update from './update';
import downloadFile from './downloadFile';

export default [get, save, update, downloadFile];
